import * as React from "react";

export function RightAlignedText(props: RightAlignedTextProps): JSX.Element {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "flex-end"
            }}
        >
            {props.text}
        </div>
    );
}

interface RightAlignedTextProps {
    text: string;
}
